import { render, staticRenderFns } from "./type12.vue?vue&type=template&id=60961bae&scoped=true&"
import script from "./type12.vue?vue&type=script&lang=js&"
export * from "./type12.vue?vue&type=script&lang=js&"
import style0 from "./type12.vue?vue&type=style&index=0&id=60961bae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60961bae",
  null
  
)

export default component.exports